<template>
  <div>
    <p v-if="showName">{{ finding.name }}<span v-if="shouldAppendNameColon">:</span></p>
    <div class="flex xs12 report-img-arrange">
      <div
        v-for="image in finding.images"
        :key="image.id"
        :class="`screenshot${imgArrange}`"
      >
        <!-- 影像遺失時印一塊看得見的佔位，不要留白格。
             報告是印在紙上給人看的：空白格沒有人分辨得出「這裡本來該有一張圖」
             還是「本來就沒圖」，但佔位可以。 -->
        <div v-if="isMissing(image)" class="report-img-gone">影像遺失</div>
        <img
          v-else
          alt=""
          :src="prefixServerImgPath(`${image.examinationID}/${image.file}`)"
          @error="onImgError(image)"
        />
        <p class="landmark" v-if="!showMetadata && image.landmarkID">
          {{ getLandMarkInfoFromID(image.landmarkID) }}
        </p>
        <Report2ImageCaption
          v-if="showMetadata"
          v-bind="metadataFields(image)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { probeImage } from '@/utils/imageProbe'
import Report2ImageCaption from '@/components/report2/Report2ImageCaption.vue'
import { shotCardFields } from '@/utils/shotCard'
export default {
  name: 'FindingItemImages',
  components: { Report2ImageCaption },
  props: {
    finding: {
      type: Object,
      required: true,
    },
    showName: {
      type: Boolean,
      default: true,
    },
    imgArrange: Number, // 圖片的排列方式 1 = 1*n , 2 = 2*n, 3*n
    showMetadata: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 已確認檔案不存在（HEAD 回 404）的 image.id
      missingIds: [],
    }
  },
  computed: {
    ...mapGetters('examinations', ['getLandmarkList']),
    shouldAppendNameColon() {
      return !String(this.finding.name || '').includes(':')
    },
  },
  methods: {
    prefixServerImgPath(path) {
      return `/api/upload/image/${path}`
    },
    isMissing(image) {
      return this.missingIds.indexOf(image.id) >= 0
    },
    /**
     * 一樣先確認是 404 才換成佔位（見 utils/imageProbe）。
     * 這裡是列印路徑，誤判的代價是「報告上印著影像遺失，但檔案其實好好的」——
     * 比破圖更糟，因為它看起來像是一句確定的陳述。
     */
    async onImgError(image) {
      if (this.isMissing(image)) return
      const url = this.prefixServerImgPath(`${image.examinationID}/${image.file}`)
      if ((await probeImage(url)) !== 'missing') return
      if (!this.isMissing(image)) this.missingIds.push(image.id)
    },
    getLandMarkInfoFromID(id) {
      return this.getLandmarkList.filter((item) => item.id == id).length
        ? this.getLandmarkList.filter((item) => item.id == id)[0].landmark
        : null
    },
    metadataFields(image) {
      return shotCardFields(image, this.getLandmarkList)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/components/reportImgArrange.scss';
.article {
  font-style: normal;
  font-weight: normal;
}
.findingAndNumber {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

/* 影像遺失的佔位。
   -webkit-print-color-adjust: exact 是必要的：預設列印會把背景色與邊框底色
   丟掉，那樣印出來就又變回一塊白的，等於沒做。內視鏡截圖是 4:3。 */
.report-img-gone {
  aspect-ratio: 4 / 3;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #9e9e9e;
  background: #f5f5f5;
  color: #757575;
  font-size: 12px;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
</style>
